import React, {Component} from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import String1Type from './types/String1Type';
import Text1Type from './types/Text1Type';
import Battery1Type from './types/Battery1Type';
import Battery2Type from './types/Battery2Type';
import Date1Type from './types/Date1Type';
import MultipleChoice1Type from './types/MultipleChoice1Type';
import Number1Type from './types/Number1Type';
import Number2Type from './types/Number2Type';
import SingleChoice3Type from './types/SingleChoice3Type';
import SingleChoice2Type from './types/SingleChoice2Type';
import SingleChoice1Type from './types/SingleChoice1Type';
import SingleChoice4Type from './types/SingleChoice4Type';
import MultipleNumber1Type from './types/MultipleNumber1Type';
import MultipleNumber2Type from './types/MultipleNumber2Type';
import MultipleNumber3Type from './types/MultipleNumber3Type';
import GeneratorClassifier2Type from './types/GeneratorClassifier2Type';

class QuestionExport extends Component {
    constructor(props) {
        super(props);
    }

    renderQuestion(question, items, parameters, extraFields) {
        switch (question.type) {
            case constants.EDITOR_TEMPLATES.STRING_1:
                return <String1Type question={question} />;
            case constants.EDITOR_TEMPLATES.TEXT_1:
                return <Text1Type question={question} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1:
                return <SingleChoice1Type question={question} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2:
                return <SingleChoice2Type question={question} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3:
                return <SingleChoice3Type question={question} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4:
                return <SingleChoice4Type question={question} />;
            case constants.EDITOR_TEMPLATES.NUMBER_1:
                return <Number1Type question={question} />;
            case constants.EDITOR_TEMPLATES.NUMBER_2:
                return <Number2Type question={question} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1:
                return <MultipleNumber1Type question={question} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2:
                return <MultipleNumber2Type question={question} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3:
                return <MultipleNumber3Type question={question} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1:
                return <MultipleChoice1Type question={question} />;
            case constants.EDITOR_TEMPLATES.DATE_1:
                return <Date1Type question={question} />;
            case constants.EDITOR_TEMPLATES.BATTERY_1:
                return <Battery1Type question={question} />;
            case constants.EDITOR_TEMPLATES.BATTERY_2:
                return <Battery2Type question={question} />;
            case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2:
                return <GeneratorClassifier2Type question={question} items={items} parameters={parameters} extraFields={extraFields} />;
        }
    }

    render() {
        const {question, items, parameters, extraFields} = this.props;
        return (
            <div>
                {this.renderQuestion(question, items, parameters, extraFields)}
            </div>
        );
    }
}

export default QuestionExport;
